import React, { Component } from 'react';

class MyCoursesView extends Component {
  render() {
    return (
      <div>
      
      </div>
    );
  }
}

export default MyCoursesView;
